import axios from './configAxios';

export const postTerminal = async (requestData) => {
  return await axios.post(`/create/`, requestData);
};
